import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';


const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
  },
  collapseRoot: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
  },
  row: {
    gap: '32px',
    margin: theme.spacing(1, 0),
    flex: 1,
    display: 'flex',
    flexFlow: 'row',
  },
  sameAsPrimary: {
    width: '100%',
    justifyContent: 'end',
    alignItems: 'center',
  },
  hidden: {
    display: 'none',
  },
  header: {
    margin: theme.spacing(2, 0),
    fontWeight: theme.typography.fontWeightFacetMedium,
  },
  subHeader: {
    margin: theme.spacing(2, 0),
    fontWeight: theme.typography.fontWeightFacetBook,
  },
  changeInformationText: {
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    row: {
      flexWrap: 'wrap',
      width: '100%',
      '& > *': {
        flexBasis: '100%',
      },
    },
  },
});

export default withStyles(styles);
